import { render } from "./BookingAppointmentType.vue?vue&type=template&id=88c68ac4&scoped=true&ts=true"
import script from "./BookingAppointmentType.vue?vue&type=script&lang=ts"
export * from "./BookingAppointmentType.vue?vue&type=script&lang=ts"

import "./BookingAppointmentType.vue?vue&type=style&index=0&id=88c68ac4&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c68ac4"]])

export default __exports__